import React from 'react';
import AgentDashboard from './AgentDashboard';

const AldoDashboard: React.FC = () => {
  const agentConfig = {
    id: 'aldo',
    displayName: 'Scout',
    icon: '/assets/logos/aldo-no-back.png',
    color: '#10b981',
    description: 'General AI assistant for UniFirst employees',
    hasTestResults: false // Scout doesn't have test results per requirement
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default AldoDashboard;